import { ScoutingCenter } from '#src/components/scoutingCenter/stats/ScoutingCenter/index.tsx';

const ScoutingCenterPage = () => {
  return <ScoutingCenter />;
};
export default ScoutingCenterPage;
